import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";

import { stockKeys } from "./query-keys";

interface UpdateSKUVars {
  sku: string;
  product_name: string;
}

export function useUpdateSKU() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ sku, product_name }: UpdateSKUVars) => {
      const { error } = await apiClient.PATCH("/v1/sku/{sku}", {
        params: { path: { sku } },
        body: { product_name },
      });
      if (error) throw error;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: stockKeys.all });
    },
  });
}
